export default "__VITE_ASSET__CjI9eE6S__"